import { NavigationProps } from './types.ts'
import useWindowSize from 'hooks/useWindowSize.tsx'
import DesktopAppNavigation from './desktop-navigation/DesktopAppNavigation.tsx'
import BottomAppNavigation from './mobile-navigation/BottomAppNavigation.tsx'
import { SMALL_DESKTOP_BREAKPOINT } from 'constants/viewport.ts'

const AppNavigation = (props: NavigationProps) => {
  // Window size
  const { isSmaller } = useWindowSize(SMALL_DESKTOP_BREAKPOINT)

  return isSmaller ? <BottomAppNavigation /> : <DesktopAppNavigation {...props} />
}

export default AppNavigation
